import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Alert, Modal, Form, Input, Button } from 'antd';
import {
  createAgentAction,
  listAgentsAction,
} from '../../../../store/actions/agents.action';
import { showToastError } from 'src/utilities/errortoast';

const AddExistingAgent = ({
  isOpen,
  setIsOpen,
  orgUuid,
  orgName,
  onAgentCreated,
}) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const [creating, setCreating] = useState(false);

  const handleClose = () => {
    form.resetFields();
    setCreating(false);
    setIsOpen(false);
  };

  const handleSubmit = (values) => {
    if (!orgUuid) {
      showToastError('Organization UUID is required');
      return;
    }

    const payload = {
      name: values.name.trim(),
      external_id: values.external_id.trim(),
    };

    if (values.phone_number?.trim()) {
      payload.phone_number = values.phone_number.trim();
    }

    setCreating(true);
    dispatch(
      createAgentAction(orgUuid, payload, (data) => {
        handleClose();
        dispatch(listAgentsAction(orgUuid));
        onAgentCreated?.(data?.agent);
      })
    ).finally(() => setCreating(false));
  };

  return (
    <Modal
      title={orgName ? `Add Existing Agent — ${orgName}` : 'Add Existing Agent'}
      open={isOpen}
      onCancel={handleClose}
      footer={null}
      width={600}
      destroyOnClose
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
        className="mt-4"
      >
        <Form.Item
          name="name"
          label="Agent Name"
          rules={[
            { required: true, message: 'Please enter agent name' },
            { min: 2, message: 'Agent name must be at least 2 characters' },
            { max: 100, message: 'Agent name must not exceed 100 characters' },
          ]}
        >
          <Input placeholder="Enter agent name" maxLength={100} />
        </Form.Item>

        <Form.Item
          name="external_id"
          label="External ID"
          rules={[
            { required: true, message: 'Please enter external ID' },
            { max: 500, message: 'External ID must not exceed 500 characters' },
          ]}
        >
          <Input placeholder="Enter external ID" maxLength={500} />
        </Form.Item>

        <Form.Item
          name="phone_number"
          label="Phone Number"
          rules={[
            {
              pattern: /^\+?[1-9]\d{1,14}$/,
              message: 'Please enter a valid phone number (E.164 format)',
            },
          ]}
        >
          <Input placeholder="e.g. +14155551234 (optional)" maxLength={16} />
        </Form.Item>

        <Alert
          type="info"
          showIcon
          className="mb-4"
          description="Skills can be added after the agent is created (Edit agent → Skills)."
        />

        <div className="flex justify-end gap-2">
          <Button onClick={handleClose}>Cancel</Button>
          <Button
            type="primary"
            htmlType="submit"
            disabled={!orgUuid}
            loading={creating}
          >
            Add Agent
          </Button>
        </div>
      </Form>
    </Modal>
  );
};

export default AddExistingAgent;
